import * as React from 'react';
import * as style from './Seller.css';
import { Logo } from '../Logo';

import { DynamicCalltrackingButton, EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import { INewbuildingBuilder, ISeller } from '../../../types/newbuilding/builder';
import { isTablet } from '../../../utils/window/isTablet';
import { cropPhone } from '../../../utils/phone/cropPhone';

export interface ISellerProps {
  newbuildingId: number;
  siteBlockId?: number | null;
  isAuthenticated?: boolean;
  builder: INewbuildingBuilder | ISeller;
  label: string;
  placeType: string;
  trackAction(builder: INewbuildingBuilder | ISeller): void;
}
export interface ISellerState {
  isFullPhone: boolean;
}

export class Seller extends React.PureComponent<ISellerProps, ISellerState> {
  public state = { isFullPhone: false };

  public showPhone = async () => {
    this.setState({ isFullPhone: true });
    if (!isTablet()) {
      this.props.trackAction(this.props.builder);
    }
  };

  public render() {
    const { builder, label, placeType } = this.props;
    const { isFullPhone } = this.state;

    return (
      <div className={style['seller']}>
        <div className={style['seller-logo']}>
          <Logo
            // @ts-ignore
            src={builder.logoUrl || builder.avatarUrl}
            name={builder.name}
          />
        </div>
        <div className={style['seller-info']}>
          <div className={style['seller-title']}>
            <div className={style['seller-name']}>{builder.name}</div>
            <div className={style['seller-label']}>{label}</div>
          </div>
          <div>
            {builder.phone && (
              <DynamicCalltrackingButton
                callable={true}
                isOpen={isFullPhone}
                onClick={this.showPhone}
                phone={cropPhone({ phone: builder.phone, isFullPhone: true })}
                blockId={this.props.siteBlockId}
                platformType={EPlatformTypes.WebMobile}
                pageType={EPageTypes.NewbuildingCard}
                className={style['seller-phone']}
                openPhoneClassName={style['seller-phone']}
                placeType={placeType}
              >
                {cropPhone({ phone: builder.phone, isFullPhone })}
              </DynamicCalltrackingButton>
            )}
          </div>
        </div>
      </div>
    );
  }
}
